import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus } from '../../../../util/util';
import Select from 'react-select';
import RCPagination from '../../UserControl/Pagination/RCPagination';
import AlertBar from '../../../Modals/AlertBar';
import ModalConfirmDelete from '../../../Modals/ModalConfirmDelete';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';
import DelerInfo from '../Content/DealerInfo'

class UserDevice extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage:1,
            currentPageSize:10,
            totalPage:0,
            userDeviceList:[],
            userNoDeviceRelated:[],
            isClearable: true,
            isDisabled: false,
            isLoading: false,
            isRtl: false,
            isSearchable: true,
            statusAlert:true,
            notification:false,
            ShowDeleteRow:false,
            userId:'',
            selectedDriver:null,
            listDriver:[{}],
            openDeviceUserRelated:false,
        }
    
    }
    
    componentWillMount(){

        const { listDriver } = this.state;

        this.getUserNoDeviceRelated();

        
    }


    componentDidMount(){
        
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
        
        let list=[];
        const { listDriver,userNoDeviceRelated } = this.state;
        
        userNoDeviceRelated.map(user => {

            list.push({
                // label:user.first_name,
                label:user.first_name+" "+user.last_name+" ("+user.login_name+")",
                value:user.user_id,
            });
        });

        this.setState({listDriver:list});
    }
    componentWillUnmount(){
        
        this.setState({
            userDeviceList:[],
            userNoDeviceRelated:[],
        });
    }

    getUserNoDeviceRelated(){

        const { currentPageSize } = this.state;
        const { user_id, user_name,token,deviceId } = this.props;

        fetch(`http://203.150.199.244/api/admin/getUserNoDeviceRelated/${deviceId}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":deviceSearch
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    userNoDeviceRelated:data.RESULT_DATA,
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onPageSizeChange(page, pageSize){
        const { currentPageSize } = this.state;
        const { user_id, user_name,token,deviceId, history } = this.props;
        const deviceIdHistory = deviceId || history.location.state.deviceId;

        fetch(`http://203.150.199.244/api/admin/getUserDeviceRelated/${deviceIdHistory}/${page}/${pageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":deviceSearch
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    userDeviceList:data.RESULT_DATA,
                    totalPage:data.RESULT_TOTAL,    
                    currentPage:page,
                    currentPageSize:pageSize,
                    selectedDriver:null,
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

        // let data=tmpdeviceList.slice((page-1)*pageSize,((page-1)*pageSize)+pageSize)
        // this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})
        // console.log('onPageSizeChange',data)
    }

    onPageSelect(page){
    
        const { currentPageSize } = this.state;
        const { user_id, user_name,token,deviceId} = this.props;
        fetch(`http://203.150.199.244/api/admin/getUserDeviceRelated/${deviceId}/${page}/${currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":name
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    deviceList:data.RESULT_DATA,
                    totalPage:data.RESULT_TOTAL,
                    currentPage:page,currentPageSize:currentPageSize})
                
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    handleChange = (selectedOption) => {
        let value = selectedOption.value;
        this.setState({ selectedDriver : value });
    }

    assignDevice(){

        // this.setState({selectedDriver: null})
        const { user_id, user_name,token,deviceId } = this.props;
        const { selectedDriver } = this.state;
        if(selectedDriver != null && deviceId != null && selectedDriver != '' && deviceId != ''){

            fetch(`http://203.150.199.244/api/admin/assignDevice/${selectedDriver.value}/${deviceId}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":deviceSearch
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {

                this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);

                if(data.RESULT_STATUS == "000"){
                    this.setState({notification:true,});
                }
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
        }else{

        }
        
    }

    deleteDevice(userId){

        this.setState({
            userId:userId,
            // ShowDeleteRow: true,
        }) 

        this.onClickConfirmDelete();
    }

    onClickCancelDelete = (status) => {
        this.setState({ ShowDeleteRow: status });
    }

    onClickConfirmDelete = () => {

        AlertConfirm("ลบผู้ใช้งาน"," ").then(isOk=>{
            if(isOk){
                const { user_id, user_name,token,deviceId } = this.props;
                const { selectedDriver ,userId} = this.state;

                    fetch(`http://203.150.199.244/api/admin/cancelDevice/${userId}/${deviceId}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        // "filter":deviceSearch
                    })
                    })
                    .then(response => { return checkStatus(response)})
                    .then(data => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }
                        
                            this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
                        
                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });    
                }
            });
    }

    onSelectDriver(val){
        this.setState({selectedDriver:val})
    }

    openDeviceUser(){

        this.setState({
            openDeviceUserRelated:true
        })
    }

    editDevice = (user) => {
        const { history } = this.props;
        console.log('editDevice:', user);
        // this.props.history.pushState({ id: '', criteriaObject }, '/users/add');
        let name = '';
        if (user.user_level === 2) {
            name = 'dealerInfo';
        }else if(user.user_level === 3){
            name = 'customerInfo';
        }else if(user.user_level === 4){
            name = 'employeeInfo';
        }else if(user.user_level === 1){
            name = 'adminInfo';
        }
        console.log(name)
        history.push({ pathname: '/admin_config', state: { sideBarName: name, isOpenDeviceUserRelated: true, deviceId: user.user_id} });
    }

    nullToEmptyString(str){

        if(str !== undefined || str !== null)
            return str+" ";

        else
            return "";
    }
    render(){
        const {deviceSelected,deviceInfo,history} = this.props;
        const {
            isClearable,
            isSearchable,
            isDisabled,
            isLoading,
            isRtl,
            userNoDeviceRelated,
            userDeviceList,
            totalPage,
            currentPageSize,
            notification,
            selectedDriver,
            ShowDeleteRow,
            listDriver,            
          } = this.state;
        
        const select=[];
        console.log('userNoDeviceRelated',userNoDeviceRelated)
        userNoDeviceRelated.map(user => {

            let first='';
            let last='';

            if(user.first_name !== undefined && user.first_name !== null)
               first = user.first_name+" ";
            
            if(user.last_name !== undefined && user.last_name !== null)   
                last = user.last_name+" ";
            
            select.push({
                // label:user.first_name,
                label:first+last+"("+user.login_name+")",
                value:user.user_id,
            });
        });
        
        let rows=[];
        userDeviceList.map((user,key) => {
            rows.push(

            <tr key={key}>
                <td >{user.user_id}</td>
                <td >{user.login_name}</td>
                <td>{user.first_name} {user.last_name}</td>
                <td></td>
                <td></td>
                <td ><p data-placement="top" data-toggle="tooltip" title="Edit">
                    <button  className="btn btn-primary btn-xs" onClick={this.editDevice.bind(this, user)}  data-title="Edit" data-toggle="modal" 
                    data-target="#editDevice"  data-backdrop="static" data-keyboard="false"><span className="fa fa-pencil" /></button></p></td>
                <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Delete">
                    <button className="btn btn-danger btn-xs" data-title="Delete" data-toggle="modal"
                        data-target="#deleteDevice" onClick={() => {this.deleteDevice(user.user_id)}} data-backdrop="static" data-keyboard="false">
                    <span className="fa fa-trash" />
                    </button>
                    </p>
                </td>
            </tr>
            )
        });
        return(
        
            <div className="container-fluid">
             { notification &&
                    <AlertBar status={this.state.statusAlert}/>
             }
             {/* { ShowDeleteRow &&
                <ModalConfirmDelete
                    onClickCancelDelete={this.onClickCancelDelete}
                    onClickConfirmDelete={this.onClickConfirmDelete}
                />
                } */}
            <div className="card">
                    <h5 class="card-header">ผู้ใช้งาน</h5>
                    <div class="card-body">
                        <div className="form-inline form-group">
                                <strong htmlFor="focusedInput" >เพิ่มผู้ใช้งาน</strong> 
                                <div className="col-md-3">
                                    {/* <input className="form-control" id="focusedInput" type="text" onKeyUp={this.handleChange}  /> */}
                                    <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    // defaultValue={selectedDriver}
                                    isDisabled={isDisabled}
                                    isLoading={isLoading}
                                    isClearable={isClearable}
                                    isRtl={isRtl}
                                    isSearchable={isSearchable}
                                    name="color"
                                    options={select}
                                    onChange={this.onSelectDriver.bind(this)}
                                    value={this.state.selectedDriver}
                                    />
                                    
                                </div>
                                <div className="col-md-1">
                                    <input type="button" className="btn btn-primary pull-right" style={{width:70}} value="เพิ่ม" onClick={() => this.assignDevice()} />
                                </div>
                        </div>
                        <div className="col-md-12 table-responsive">
                            <table  className="table table-bordred table-striped table-hover ">
                            <thead >
                                <tr>
                                <th>#</th>				
                                <th style={{minWidth:120}}>ชื่อผู้ใช้งาน</th> 
                                <th style={{minWidth:200}}>ชื่อ - นามสกุล</th>
                                <th style={{minWidth:120}}>บริษัท</th>
                                <th style={{minWidth:120}}>ใช้งานล่าสุด</th>
                                <th style={{width:20}}></th>
                                <th style={{width:20}}></th>                                
                                </tr></thead>
                            <tbody>
                                {rows}
                            </tbody>
                            </table>
                            <RCPagination 
                                onSelect={this.onPageSelect.bind(this)} 
                                onShowSizeChange={this.onPageSizeChange.bind(this)}  
                                total={totalPage} 
                                pageSize={currentPageSize}
                            />
                        </div>   

                        { this.state.openDeviceUserRelated && 
                            <DelerInfo />
                        }   
                    </div>
                </div>
               
            </div>
            
        );
    }
}
UserDevice.defaultProps = {
    deviceSelected:{},
    deviceInfo:{},
}

UserDevice.propTypes = {
    deviceSelected: PropTypes.object,
    deviceInfo:PropTypes.object,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    deviceId:  PropTypes.string.isRequired,
    history: PropTypes.func.isRequired
}

export default UserDevice;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/UserDevice.js